module.exports = __webpack_public_path__ + "static/flow-320f807b0c2c5430ca32e4e6d03e289c.webp";